import { Component } from "react";
import { Container, FormLabel, Button, Modal } from "react-bootstrap";
import { CustomTextArea } from "./customTextArea";
import { ChoiceQuestion } from "./choiceQuestion";

export class FormDisplay extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selections: new Array(props.templateInfo.questions.length).fill(null),
            emptySubmissionModal: false,
        }
    }

    componentDidUpdate(_prevProps, prevState) {
        if (prevState !== this.state) {
            this.props.onFormUpdate(this.state.selections)
        }
    }

    handleUpdate = (idx, selection) => {
        let newSelections = [...this.state.selections]
        newSelections[idx] = selection
        this.setState({
            selections: newSelections
        })
    }

    handleTextUpdate = idx => (input) => {
        this.handleUpdate(idx, input)
    }

    handleFormSubmit = async () => {
        const hasEduSelected = this.props.hasEducatorSelected()
        if (!hasEduSelected) {
            alert('Educator has not been selected')
            return
        }
        if (this.state.selections && this.state.selections.includes(null)) {
            this.setState({emptySubmissionModal: true})
            return
        }
        const success = await this.props.onFormSubmit()
        if (success) {
            this.setState({selections: new Array(this.props.templateInfo.questions.length).fill(null)})
        }
    }

    handleFormEmptySubmit = async () => {
        const success = await this.props.onFormSubmit(true)
        if (success) {
            this.setState({
                selections: new Array(this.props.templateInfo.questions.length).fill(null),
                emptySubmissionModal: false,
            })
        }
    }

    closeEmptySubmit = async () => {
        this.setState({
            emptySubmissionModal: false,
        })
    }

    render() {
        return <>
            {this.props.templateInfo && this.props.templateInfo.questions.map((val, idx) => 
                <Container key={idx}>
                    {val.questionType === 0 &&
                        <Container>
                            <FormLabel className="mt-3">{idx + 1}. {val.question}</FormLabel>
                            <CustomTextArea propagateInput={this.handleTextUpdate(idx)} value={this.state.selections[idx]} className="mx-3"/>
                        </Container>
                    }
                    {val.questionType !== 0 &&
                        <ChoiceQuestion propagateAnswer={this.handleUpdate} idx={idx} value={this.state.selections[idx]} questionDetails={val}/> 
                    }
                </Container>
            )}
            <Button className="my-3 mx-4" onClick={async () => await this.handleFormSubmit()}>Submit</Button>

            <Modal show={!!this.state.emptySubmissionModal} onHide={() => {this.closeEmptySubmit()}}>
                <Modal.Header>
                    <Modal.Title>Are you sure you wish to proceed with this form submission?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    There are form items that have been left blank.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => {this.closeEmptySubmit()}}>
                        Cancel
                    </Button>
                    <Button variant="warning" onClick={() => {this.handleFormEmptySubmit()}}>
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    }
}